/* globals Store */
import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import {UploadFile} from '@/vue-dlb/models'
import {DownloadFile} from '@/vue-dlb/models'
import appUtil from '@/vue-dlb/utils/app-util'
import config from '@/vue-caas/config/config.js';

const isDlbMybatis = config.isDlbMybatis;

import {
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
  selectUserDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";

const state = {
  mainGrid: [],
  appliedList: [],
  historyList: [],
  fflayoutData: [],
  dataSet01Source: [],
};

const getters = {
};

const actions = {
  queryList: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("mainGrid");
    const retSet2 = new ObjDataSet("appliedList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DS02:EDP_FFL_LIST_MAN_FFLAY_MST_FN|DS03:EDP_FFL_LIST_MAN_FFLAY_MAP_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  updateLock: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("updateLock");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "FFLayoutManager";
      trSet.tranMethod = "updateLock";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_FFL_UPD_MAN_FFLAY_LOCK_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }


    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  saveAddFFLayout: async ({ commit }, paramItems) => {
    // Local에서 업로드 하는 파일들(FlatFile Layout Excel, CSV) 먼저 서버에 업로드 하기
    // Excel File Upload
    let uploadfile = new UploadFile();
    uploadfile.data[0].DIV_KUBUN = 'ASSET';
    uploadfile.data[0].BIZ_KUBUN = 'FILE_FFL';
    uploadfile.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
    uploadfile.data[0].USER_KUBUN = $cookies.get('');
    uploadfile.data[0].SUB_DIR = '';
    uploadfile.data[0].RENAME_YN = 'Y';
    uploadfile.data[0].FILE_NAME = paramItems.data[0].fflfile.name;
    uploadfile.data[0].file = paramItems.data[0].fflfile;
    // Upload FlatFile Layout File Data
    const retSet = new ObjDataSet("UploadedFile");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("saveAddFFLayoutLocal");
    condSet = appUtil.addDataHeader(uploadfile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
    const formData = new FormData();
    formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
    formData.append('trSet', JSON.stringify(trSet));
    await api.trFileSend("Fileupload", formData).then(res => {
      let resdata = res.data;
      var trset = JSON.parse(JSON.stringify(resdata));
      var datasets = trset.DataSets;
      var datarows = datasets[0].DataRows;
      //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
      paramItems.data[0].FILE_ID = datarows[0].FILE_NAME;  // FlatFile Layout Excel Server file ID
      paramItems.data[0].FILE_SIZE = datarows[0].FILE_BYTE;  // FlatFile Layout Excel Server file Size
      paramItems.data[0].FFL_FILE_NAME = paramItems.data[0].fflfile.name;  // FlatFile Layout File Name
    });

    if (paramItems.data[0].csvfile != null) {
      // CSV File Upload
      let uploadcsv = new UploadFile();
      uploadcsv.data[0].DIV_KUBUN = 'ASSET';
      uploadcsv.data[0].BIZ_KUBUN = 'FILE_FFL';
      uploadcsv.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
      uploadcsv.data[0].USER_KUBUN = $cookies.get('user-id');
      uploadcsv.data[0].SUB_DIR = '';
      uploadcsv.data[0].RENAME_YN = 'Y';
      uploadcsv.data[0].FILE_NAME = paramItems.data[0].csvfile.name;
      uploadcsv.data[0].file = paramItems.data[0].csvfile;
      // Upload FlatFile Layout File Data
      const retSet2 = new ObjDataSet("UploadedFile");
      let condSet2 = new ObjDataSet("condSet");
      let trSet2 = new ObjTrSet("saveAddFFLayoutCSV");
      condSet2 = appUtil.addDataHeader(uploadcsv, condSet2);
      trSet2.AddDataSet("I", "DS01", condSet2);
      trSet2.AddDataSet("O", "DS02", retSet2);
      trSet2 = selectUserDataSet(trSet2);   // call directly only for uploading file.
      const formData2 = new FormData();
      formData2.append('file', uploadcsv.data[0].file, uploadcsv.data[0].FILE_NAME);
      formData2.append('trSet', JSON.stringify(trSet2));
      await api.trFileSend("Fileupload", formData2).then(res => {
        let resdata = res.data;
        var trset = JSON.parse(JSON.stringify(resdata));
        var datasets = trset.DataSets;
        var datarows = datasets[0].DataRows;
        //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
        paramItems.data[0].CSV_FILE_ID = datarows[0].FILE_NAME;  // FlatFile Layout CSV Server file ID
        paramItems.data[0].CSV_FILE_NAME = paramItems.data[0].csvfile.name;  // CSV File Name
      });
    }

    /// Insert Data
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("saveAddFFLayoutInsertData");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.tranID = "FFLayoutManager";
    trSet3.tranMethod = "saveAddFFLayout";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  queryHistoryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("historyList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryHistoryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_FFL_LIST_MAN_FFLAY_HST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  saveCurrentVer: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveCurrentVer");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "FFLayoutManager";
      trSet.tranMethod = "saveCurrentVer";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_FFL_UPD_MAN_FFLAY_CURVER_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteFFLayout: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteFFLayout");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "FFLayoutManager";
    trSet.tranMethod = "deleteFFLayout";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteSelectedHistory: async ({ commit }, paramItems) => {
    /// Insert Data
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("deleteSelectedHistory");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.tranID = "FFLayoutManager";
    trSet3.tranMethod = "deleteFFLayoutHistory";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  checkInFFLayout: async ({ commit }, paramItems) => {
    // Local에서 업로드 하는 파일들(FlatFile Layout Excel, CSV) 먼저 서버에 업로드 하기
    // Excel File Upload
    let uploadfile = new UploadFile();
    uploadfile.data[0].DIV_KUBUN = 'ASSET';
    uploadfile.data[0].BIZ_KUBUN = 'FILE_FFL';
    uploadfile.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
    uploadfile.data[0].USER_KUBUN = $cookies.get('user-id');
    uploadfile.data[0].SUB_DIR = '';
    uploadfile.data[0].RENAME_YN = 'Y';
    uploadfile.data[0].FILE_NAME = paramItems.data[0].fflfile.name;
    uploadfile.data[0].file = paramItems.data[0].fflfile;
    // Upload FlatFile Layout File Data
    const retSet = new ObjDataSet("UploadedFile");
    let condSet = new ObjDataSet("condSet");
    let trSet = new ObjTrSet("checkInFFLayout");
    condSet = appUtil.addDataHeader(uploadfile, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
    const formData = new FormData();
    formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
    formData.append('trSet', JSON.stringify(trSet));
    await api.trFileSend("Fileupload", formData).then(res => {
      let resdata = res.data;
      var trset = JSON.parse(JSON.stringify(resdata));
      var datasets = trset.DataSets;
      var datarows = datasets[0].DataRows;
      //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
      paramItems.data[0].FILE_ID = datarows[0].FILE_NAME;  // FlatFile Layout Excel Server file ID
      paramItems.data[0].FILE_SIZE = datarows[0].FILE_BYTE;  // FlatFile Layout Excel Server file Size
      paramItems.data[0].FFL_FILE_NAME = paramItems.data[0].fflfile.name;  // FlatFile Layout File Name
    });

    /// Insert Data
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("checkInFFLayout");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.tranID = "FFLayoutManager";
    trSet3.tranMethod = "checkInFFLayout";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  getFFLayoutInfo: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("fflayoutData");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getFFLayoutInfo");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_FFL_LIST_MAN_FFLAY_MST_MOD_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  modifyFFLayout: async ({ commit }, paramItems) => {
    if(paramItems.data[0].csvfile != null)
    {
      // CSV File Upload
      let uploadfile = new UploadFile();
      uploadfile.data[0].DIV_KUBUN = 'ASSET';
      uploadfile.data[0].BIZ_KUBUN = 'FILE_FFL';
      uploadfile.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
      uploadfile.data[0].USER_KUBUN = $cookies.get('user-id');
      uploadfile.data[0].SUB_DIR = '';
      uploadfile.data[0].RENAME_YN = 'Y';
      uploadfile.data[0].FILE_NAME = paramItems.data[0].csvfile.name;
      uploadfile.data[0].file = paramItems.data[0].csvfile;
      // Upload FlatFile Layout File Data
      const retSet = new ObjDataSet("UploadedFile");
      let condSet = new ObjDataSet("condSet");
      let trSet = new ObjTrSet("modifyFFLayout");
      condSet = appUtil.addDataHeader(uploadfile, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.AddDataSet("O", "DS02", retSet);
      trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
      const formData = new FormData();
      formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
      formData.append('trSet', JSON.stringify(trSet));
      await api.trFileSend("Fileupload", formData).then(res => {
        let resdata = res.data;
        var trset = JSON.parse(JSON.stringify(resdata));
        var datasets = trset.DataSets;
        var datarows = datasets[0].DataRows;
        //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
        paramItems.data[0].CSV_FILE_ID = datarows[0].FILE_NAME;  // FlatFile Layout Excel Server file ID
        paramItems.data[0].CSV_FILE_NAME = paramItems.data[0].csvfile.name;  // FlatFile Layout File Name
      });
    }

    /// Insert Data
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("modifyFFLayout");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.tranID = "FFLayoutManager";
    trSet3.tranMethod = "modifyFFLayout";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
};

const mutations = {
  mainGrid (state, datarows) {
    state.mainGrid = datarows;
    state.mainGridSource = datarows;
    state.dataSet01Source = datarows;
  },
  appliedList (state, datarows) {
    state.appliedList = datarows;    
  },
  historyList (state, datarows) {
    state.historyList = datarows;
  },
  fflayoutData (state, datarows) {
    state.fflayoutData = datarows;
  },
  'SET_STORE_FLAT_FILE_FILTER' (state, filter) {
    let datarows = state.dataSet01Source;
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item =>  {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.mainGrid = listResult;
  },

};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
